import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';
import type { Reservation } from '@/api/reservations';

type Variables = {
  id: number;
  carId: number;
};
export type ChangeCarResponse = {
  data: Reservation;
};

export const useChangeCar = createMutation<
  ChangeCarResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/internal/partners/reservations/${variables.id}/change-car`,
      method: 'PUT',
      data: {
        car_id: variables.carId,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
